import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { TransactionLineTemplate } from "../_types/transaction-line-template";

@Injectable({
    providedIn: 'root',
})
export class TransactionsLinesTemplatesService extends Service<TransactionLineTemplate> {
    public override type = 'transactionLineTemplates';
    public override url = 'invoicing/transactionLineTemplates';
}
